module.exports = addCollector
module.exports.DOC_TYPE = 'snapshot-collector'

const dateToIdFriendlyTimestamp = require('./tools/date-to-id-friendly-timestamp')
const { SHIPMENT_VERSIONS } = require('./constants')

const toCollectorId = (snapshotId, date) => {
  const timestamp = dateToIdFriendlyTimestamp(date)
  const millis = String(date.getMilliseconds()).padStart(3, '0')
  return `${snapshotId}:collector:${timestamp}-${millis}`
}

async function addCollector (state, snapshotId, collector) {
  const { collectorType, name, phoneNumber, signature, comment } = collector

  const now = new Date()
  const createdAt = now.toISOString()
  const createdBy = state.user.name
  const _id = toCollectorId(snapshotId, now)

  const doc = {
    _id,
    type: 'snapshot-collector',
    version: SHIPMENT_VERSIONS.VERSION_2,
    createdAt,
    createdBy,
    collectorType,
    name,
    phoneNumber,
    signature
  }

  if (comment) {
    doc.comment = comment
  }

  await state.dal.shipment.write(state, doc)

  return doc
}
